import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { u as useKeyboardClick } from './utils.js';

const mapyMapmenuMapsetCss = "mapy-mapmenu-mapset{display:block;border-radius:8px;color:rgba(1, 30, 57, 0.6)}mapy-mapmenu-mapset:focus-visible{outline:2px solid currentColor;outline-offset:-2px}mapy-mapmenu-mapset:hover mapy-mapmenu-mapset-preview{outline:1px solid #1eae00;outline-offset:-1px;color:#1eae00}mapy-mapmenu-mapset:not([active]) mapy-mapmenu-mapset-options{background:rgba(1, 30, 57, 0)}mapy-mapmenu-mapset:not([active]) mapy-mapmenu-mapset-options mapy-mapmenu-mapset-options{padding:0}mapy-mapmenu-mapset:not([active]) mapy-mapmenu-mapset-option{display:none}mapy-mapmenu-mapset[active] mapy-mapmenu-mapset-preview{outline:3px solid #1eae00;outline-offset:-3px}mapy-mapmenu-mapset:hover mapy-mapmenu-mapset-main,mapy-mapmenu-mapset[active] mapy-mapmenu-mapset-main{color:#1eae00}mapy-mapmenu-mapset[active] mapy-mapmenu-mapset-options>mapy-mapmenu-mapset-options{margin:-6px -6px -2px -6px}mapy-mapmenu-mapset[active] mapy-mapmenu-mapset-main{font-weight:700}";

var __classPrivateFieldGet = (undefined && undefined.__classPrivateFieldGet) || function (receiver, state, kind, f) {
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (undefined && undefined.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
  if (kind === "m")
    throw new TypeError("Private method is not writable");
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _MapyMapmenuMapset_originalTabIndex, _MapyMapmenuMapset_cleanup;
const MapyMapmenuMapset$1 = /*@__PURE__*/ proxyCustomElement(class MapyMapmenuMapset extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    _MapyMapmenuMapset_originalTabIndex.set(this, undefined);
    _MapyMapmenuMapset_cleanup.set(this, null);
    this.disabled = false;
    this.active = false;
  }
  watchPropHandler(newValue) {
    if (newValue) {
      this.hostElement.tabIndex = -1;
    }
    else {
      this.hostElement.tabIndex = __classPrivateFieldGet(this, _MapyMapmenuMapset_originalTabIndex, "f");
    }
  }
  connectedCallback() {
    __classPrivateFieldSet(this, _MapyMapmenuMapset_cleanup, useKeyboardClick(this.hostElement), "f");
    if (!this.hostElement.hasAttribute('tabindex')) {
      this.hostElement.tabIndex = 0;
    }
    __classPrivateFieldSet(this, _MapyMapmenuMapset_originalTabIndex, this.hostElement.getAttribute('tabindex'), "f");
    if (this.disabled) {
      this.hostElement.tabIndex = -1;
    }
  }
  disconnectedCallback() {
    var _a;
    (_a = __classPrivateFieldGet(this, _MapyMapmenuMapset_cleanup, "f")) === null || _a === void 0 ? void 0 : _a.call(this);
  }
  render() {
    return h(Host, null, h("slot", null));
  }
  get hostElement() { return this; }
  static get watchers() { return {
    "disabled": ["watchPropHandler"]
  }; }
  static get style() { return mapyMapmenuMapsetCss; }
}, [4, "mapy-mapmenu-mapset", {
    "disabled": [516],
    "active": [516]
  }]);
_MapyMapmenuMapset_originalTabIndex = new WeakMap(), _MapyMapmenuMapset_cleanup = new WeakMap();
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["mapy-mapmenu-mapset"];
  components.forEach(tagName => { switch (tagName) {
    case "mapy-mapmenu-mapset":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, MapyMapmenuMapset$1);
      }
      break;
  } });
}
defineCustomElement$1();

const MapyMapmenuMapset = MapyMapmenuMapset$1;
const defineCustomElement = defineCustomElement$1;

export { MapyMapmenuMapset, defineCustomElement };

//# sourceMappingURL=mapy-mapmenu-mapset.js.map